import type { Map as ImmutableMap } from 'immutable';

import type { Category } from '../categories/categoriesTypes';
import type { TaxLineItem } from './taxLineItemsTypes';

type TaxLineItemNameMatcher = (name: string) => boolean;

export const categoryMatchesTaxLineItemName = (
  category: Category,
  taxLineItemsById: ImmutableMap<string, TaxLineItem> | undefined,
  matchesName: TaxLineItemNameMatcher,
): boolean => {
  if (!taxLineItemsById || !category) return false;
  const taxLineItemIds = [category.txfId, ...Object.values(category.txfIds ?? {})].filter((id): id is string =>
    Boolean(id),
  );

  return taxLineItemIds.some((id) => {
    const name = taxLineItemsById.get(id)?.name;
    return name ? matchesName(name) : false;
  });
};
